import React from 'react';
import { FilterPanelHeader } from '@src/common/FilterPanelPage/FilterPanelHeader';
import { RiskScoresBreadcrumbs } from './RiskScoresBreadcrumbs';
import { RiskActivitySelect } from './filterPanelComponents/RiskActivitySelect';
import { FraudTypeSelect } from './filterPanelComponents/FraudTypeSelect';
import { SearchButton } from './filterPanelComponents/SearchButton';

export const RiskScoresFilterPanel = () => {
  return (
    <React.Fragment>
      <RiskScoresBreadcrumbs />
      <FilterPanelHeader />
      <RiskActivitySelect />
      <FraudTypeSelect />
      <SearchButton />
    </React.Fragment>
  );
};
